import type { HunterSearchDto } from "Infrastructure/Api/Api";
import type { Control, FieldValues } from "react-hook-form";
import { HunterCard } from "Components/Shared/Inputs/HunterList/HunterCard";

type Props<FormType extends FieldValues> = {
  control: Control<FormType>;
  hunters: Array<HunterSearchDto>;
  hunterLicenseIDExceedingLimit?: string;
  onRemoveHunter: (licensePublicID: string) => void;
  onCommissionUpdate: (licensePublicID: string) => void;
};

export const HunterList = <T extends object>({
  hunters,
  control,
  hunterLicenseIDExceedingLimit,
  onRemoveHunter,
  onCommissionUpdate,
}: Props<T>) => (
  <>
    {hunters.map((hunter, index) => {
      const { licensePublicID } = hunter;
      const hasError = hunterLicenseIDExceedingLimit === licensePublicID;

      return (
        <HunterCard
          key={licensePublicID || index} //On PROD unique licensePublicID should be always there
          hunter={hunter}
          control={control}
          onRemoveHunter={onRemoveHunter}
          onCommissionUpdate={() =>
            licensePublicID && onCommissionUpdate(licensePublicID)
          }
          hasError={hasError}
        />
      );
    })}
  </>
);
